export default __webpack_public_path__ + "static/media/bw.84fea591.svg";